<!--  -->
<template>
  <section class="common-tips">
    <!-- 标题 + 分享 -->
    <div class="title-warper">
      <div class="title pf-medium">
        <img
          v-if="product.source * 1 === 5 && !isHideUTag"
          src="../../../../../assets/images/孕产U选-详情标签@3x.png"
        />
        <span v-if="product.selfPurchase" class="self">{{
          product.selfPurchaseName
        }}</span>
        {{ product.spuName }}
      </div>
      <ShareButton
        v-if="showShare"
        class="share"
        :promotion-info="sharePromotion"
      >
        <div class="share_btn">
          <img
            src="data:image/png;base64,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"
          />
          <span>分享</span>
        </div>
      </ShareButton>
    </div>
    <!-- 价格 -->
    <div class="sub-title">
      <div class="price">
        <!-- 福袋价 -->
        <template v-if="isBlessEligible || isBlessScorable">
          <div class="left">
            <template v-if="isBlessScorable">
              <span
                :class="`${productDetail.price} ${productDetail.bless}`"
                v-html="scoreSection + `<em> 或 </em>`"
              ></span>
            </template>
            <span
              :class="`${productDetail.price} ${productDetail.bless}`"
              v-html="priceSection"
            ></span>
          </div>
          <!-- 福袋符合条件且没有领取 显示用户状态标记 -->
          <div class="bless-tag">
            <img src="@/assets/images/icon_black_gold.png" />
            <img
              v-if="blessingBag.type === 1 || blessingBag.type === 3"
              src="@/assets/images/icon_new_baby.png"
            />
            <img
              v-if="blessingBag.type === 2 || blessingBag.type === 3"
              src="@/assets/images/icon_yunma.png"
            />
          </div>
        </template>
        <!-- 其他价 -->
        <template v-else>
          <!-- 促销价/促销客群价 ../../common/promo-tip/index -->
          <PromoTips v-if="mixInfo.isReallyCheap" />
          <!-- 非促销客群价+标签 -->
          <div class="left" v-else-if="!showShareEarn && userGroupPriceSection">
            <span
              :class="productDetail.price"
              v-html="userGroupPriceSection"
            ></span>
            <!-- 客群标签 -->
            <img
              v-if="userGroupImg"
              class="user-group-price-tag"
              :src="userGroupImg"
            />
          </div>
          <!-- 非促销价 -->
          <div class="left" v-else>
            <span :class="productDetail.price" v-html="priceSection"></span>
          </div>
          <!-- 分享赚金额 ../shareEarn/index -->
          <ShareEarn v-if="showShareEarn"></ShareEarn>
        </template>
      </div>
      <div class="right" v-if="product.saleNum > 0">
        已售{{ this.numSale }}份
      </div>
    </div>
    <!-- 普通会员价（最终显示了客群价标签时出现） -->
    <div
      v-if="
        !isBlessEligible &&
        !isBlessScorable &&
        !mixInfo.isReallyCheap &&
        !showShareEarn &&
        userGroupPriceSection &&
        userGroupImg
      "
      class="user-normal-price"
    >
      普通会员价 ¥{{ normalPrice.num }}{{ normalPrice.showQi ? ' 起' : '' }}
    </div>
    <!-- 支持定金尾款 20220611弱化预付定金模式-->
    <!-- <div class="deposit" v-if="isSupportDeposit()">
      {{ mixInfo.depositTips }}
    </div> -->
  </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState } from 'vuex'
import ShareButton from '@/components/share/ShareButton.vue'
import { E_PROMOTION_TYPE } from '@/config'
import { isEmptyObject } from '@/utils'
import mixProm from '@/mixin/mixProm'
import { hideUTag } from '@/business/childbirth-service-package'
import PromoTips from '../../common/promo-tip/index'
import ShareEarn from '../shareEarn/index'
import utils from '@/plugins/utils'
import { showShareEarnInProductDetail } from '@/router/home/utils'

export default {
  mixins: [mixProm],
  //import引入的组件需要注入到对象中才能使用
  components: {
    PromoTips,
    ShareEarn,
    ShareButton
  },
  data() {
    //这里存放数据
    return {
      showShare: false,
      isHideUTag: true // 为了更好的视觉交互体验 默认隐藏
    }
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState([
      'viewName',
      'comments',
      'commentCount',
      'selectedWorker',
      'selectedAddress',
      'selectedTime',
      'locationInfo',
      'selectedSku',
      'isMinProgram',
      'otherServiceDatas'
    ]),
    ...mapState('promotionInfo', {
      promotionInfo: state => state.promotionInfo
    }),
    numSale() {
      let num = this.product.saleNum
      if (num > 9999) {
        num = `${parseFloat(Number(num / 10000).toFixed(1))}万`
      }
      return num
    },
    orginprice() {
      return this.selectedSku.orginprice / 100
    },
    sharePromotion() {
      if (this.mixInfo) {
        return {
          tag: this.mixInfo.tagName || this.mixInfo.tag
        }
      }
      return {}
    },
    showShareEarn() {
      return showShareEarnInProductDetail()
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    hideUTag(this)
    this.showShare = utils.isHzwApp() || this.isMinProgram
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
}
</script>

<style lang="scss" module="productDetail">
@import '~@/assets/css/mixin';
.price {
  line-height: rem(48px);
  font-size: rem(48px);
  font-weight: 500;
  color: #ff5900;
  i {
    line-height: rem(27px);
    font-size: rem(26px);
    font-weight: 500;
    margin-right: rem(4px);
  }
  :not(:first-of-type) {
    margin-left: rem(4px);
  }
}
.price.bless {
  line-height: rem(44px);
  font-size: rem(36px);
  font-weight: 500;
  color: #ff5900;
  i {
    line-height: normal;
    font-size: rem(28px);
    font-weight: 500;
    margin-right: rem(4px);
  }
  em {
    line-height: normal;
    font-size: rem(28px);
    color: #666666;
    font-weight: 500;
    white-space: pre-wrap;
  }
  :not(:first-of-type) {
    margin-left: rem(4px);
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.common-tips {
  padding: rem(24px) rem(0px) rem(42px);
  margin-left: rem(24px);
  margin-right: rem(24px);
  // border-bottom: rem(1.6px) solid #f0f0f0;
  @include border(bottom, #f0f0f0);

  min-height: rem(160px);
  .title-warper {
    display: flex;
    align-items: center;
  }
  .share {
    margin-left: rem(20px);

    .share_btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: rem(44px);
        height: rem(44px);
      }
      span {
        margin-top: rem(6px);
        color: #333;
        font-size: rem(18px);
      }
    }
  }
  .title {
    font-size: rem(32px);
    color: #333333;
    word-wrap: break-word;
    letter-spacing: 0;
    line-height: rem(44px);
    font-weight: 700;
    flex: 1;

    .self {
      height: rem(28px);
      font-size: rem(20px);
      line-height: rem(28px);
      display: inline-block;
      color: white;
      padding: 0 rem(8px);
      vertical-align: top;
      margin-top: rem(8px);
      margin-right: rem(8px);
      border-radius: rem(14px);
      background: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
    }

    img {
      width: rem(106px);
      height: rem(36px);
      margin-right: rem(8px);
      vertical-align: middle;
      position: relative;
      top: rem(-3px);
    }
  }
  .sub-title {
    display: flex;
    align-items: center;
    line-height: normal;
    justify-content: space-between;
    margin-top: rem(16px);
    .price {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      .left {
        flex: none;
        display: flex;
        align-items: center;
        margin-right: rem(8px);
        .or {
          line-height: rem(48px);
          color: #666666;
          font-weight: 500;
          font-size: rem(28px);
          white-space: pre-wrap;
        }
        .user-group-price-tag {
          display: block;
          width: auto;
          height: rem(24px);
          margin-left: rem(8px);
          margin-top: rem(8px);
        }
      }
      .bless-tag {
        flex: none;
        display: flex;
        margin-top: rem(12px);
        align-items: center;
        > img {
          height: rem(24px);
          margin-right: rem(6px);
        }
      }
    }
    .right {
      flex: none;
      font-size: rem(24px);
      color: #4d4d4d;
    }
  }
  .user-normal-price {
    margin-top: rem(13px);
    line-height: rem(30px);
    color: #333333;
    font-size: rem(24px);
  }
  .deposit {
    font-size: rem(24px);
    color: #ff5900;
    line-height: rem(30px);
    margin-top: rem(16px);
  }
}
</style>
